<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  step: number;
  subtitles?: { step1?: string; step2?: string; step3?: string };
}>();
</script>

<template>
  <v-stepper
    :model-value="step"
    flat
    alt-labels
    bg-color="transparent"
    class="flex-grow-0 border-b border-color-line-border rounded-0">
    <v-stepper-header>
      <v-stepper-item
        :value="1"
        :complete="step > 1"
        color="primary"
        :title="t('assetCheckWizard.steps.location')"
        :subtitle="subtitles?.step1" />
      <v-divider />
      <v-stepper-item
        :value="2"
        :complete="step > 2"
        color="primary"
        :title="t('assetCheckWizard.steps.status')"
        :subtitle="subtitles?.step2" />
      <v-divider />
      <v-stepper-item
        :value="3"
        :complete="step > 3"
        color="primary"
        :title="t('assetCheckWizard.steps.state')"
        :subtitle="subtitles?.step3" />
    </v-stepper-header>
  </v-stepper>
</template>
